
const Utils = {
    sleep: (delay) => new Promise((resolve) => setTimeout(resolve, delay)),
    Type_Calibration: {
        temp: 0,
        push: 1,
        finish: 2
    },
}



export default Utils;